export * from "./dtm-language.interceptor";
export * from "./i18n.models";
export * from "./pipes/localize-date.pipe";
export * from "./pipes/localize-number.pipe";
export * from "./pipes/system-translation.pipe";
export * from "./services/i18n.service";
export * from "./services/translation-helper.service";
export * from "./shared-i18n.module";
export * from "./shared-i18n.tokens";
import { getLanguageQueryParam } from "./i18n.utils";

export const I18nUtils = {
    getLanguageQueryParam: getLanguageQueryParam,
};
